import { type IEmbedFlourish } from '@/types/IEmbeds';

export default function Flourish ({ src }: IEmbedFlourish) {
  return (
    <iframe
      className='flourish-embed-iframe'
      loading='lazy'
      sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'
      src={`https://flo.uri.sh/${src}/embed`}
      style={{ border: 0, height: '600px', width: '100%' }}
      title='Interactive or visual content'
    />
  );
}
